<template>
    <div>
    <div
      class="flex w-full h-full gap-4 min-h-[300px]"
      style="min-height: 400px; max-height: 400px"
    >
      <div
        class="border border-solid p-4 rounded-lg w-1/2 flex flex-col gap-2 overflow-y-scroll min-h-[300px]"
      >
        <div class="flex gap-2 items-center">
          <vs-input
            class="inputx mb-4 mt-1"
            v-model="accountName"
            name="Search"
            :label="$t('Search')"
            @keyup.enter="search()"
          />
          <vs-button
            radius
            class="mt-3"
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-search"
            :disabled="disable"
            @click="search()"
          ></vs-button>
        </div>

        <div class="rounded-lg w-1/2" v-for="account in subsidiaryAccounts">
          <div
            class="cursor-pointer h-12 border hover:bg-grey rounded-lg items-center flex mr-5 w-auto pr-5"
            :class="
              account.selected === true ? 'bg-primary' : 'bg-transparent'
            "
            @click="subsidiarySelect(account)"
          >
            {{ account.name }} ({{  account.code}})
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-2 items-center justify-center">
        <vs-button
          size="small"
          icon-pack="feather"
          icon="icon-chevrons-left"
          type="border"
          :disabled="
            subsidiaryAccounts &&
            subsidiaryAccounts.length === subsidiaryAccountsSelected.length
          "
          @click="sendAllToAssign()"
        >
        </vs-button>

        <vs-button
          size="small"
          icon-pack="feather"
          icon="icon-chevron-left"
          type="border"
          @click="sendToAssign()"
        >
        </vs-button>
        <vs-button
          size="small"
          icon-pack="feather"
          icon="icon-chevron-right"
          type="border"
          @click="sendToUnassign()"
        >
        </vs-button>
        <vs-button
          size="small"
          icon-pack="feather"
          icon="icon-chevrons-right"
          type="border"
          :disabled="
            subsidiaryAccountsSelected &&
            subsidiaryAccountsSelected.length === 0
          "
          @click="sendAllToUnassign()"
        >
        </vs-button>
      </div>

      <div
        class="border border-solid p-4 rounded-lg w-1/2 flex flex-col gap-2 overflow-y-scroll min-h-[300px]"
      >
        <div
          class="rounded-lg w-1/2"
          v-for="account in subsidiaryAccountsSelected"
        >
          <div
            class="cursor-pointer h-12 border hover:bg-grey rounded-lg items-center flex mr-5 w-auto pr-5"
            :class="
              account.selectedChild === true ? 'bg-primary' : 'bg-transparent'
            "
            @click="subsidiarySelectedSelect(account)"
          >
            {{ account.name }} ({{  account.code}})
          </div>
        </div>
      </div>
    </div>
    <vs-button
        type="filled"
        class="float-right mb-4 mt-12"
        @click.prevent="submitForm"
        >{{ $t("Save") }}</vs-button
      >
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {

  data() {
    return {
      subsidiaryAccountsSelected: [],
      subsidiaryAccounts: [],
      AccountTitle: "",
      accountName: "",
      disable:false,
    };
  },

  mounted() {
    this.childId = this.$route.params.id;
    this.getData()
    this.getChilds()
  },
  methods: {
    ...mapActions({
      updateAccount: "costCenter/createAccountPartyCostTitle",
      fetchDetails: "costCenter/fetchAccount",
      searchDetails: "costCenter/fetchAccountsByname",
      fetchChildsData: "costCenter/fetchChildsDataCostTitle",
    }),
    getData() {
      this.fetchDetails().then((r) => {
        r.forEach((element, index) => {
          this.subsidiaryAccounts.push({
            id: element.id,
            name: element.name,
            code: element.code,
            type:element.type,
            selected: false,
            selectedChild: false,

          });
        });
      });
    },
    getChilds() {
        this.fetchChildsData(this.childId).then((r) => {
        r.forEach((element, index) => {
          this.subsidiaryAccountsSelected.push({
            id: element.id,
            name: element.name,
            code: element.code,
            type:element.type,
            selectedChild: false,
          });
        });
      });

    },
    search() {
      this.subsidiaryAccounts = [];
      this.disable = true;
      this.searchDetails(this.accountName).then((r) => {
        r.forEach((element, index) => {
          // var selected = this.subsidiaryAccountsSelected.findIndex(
          //   (x) => x.id == element.id
          // );
          this.subsidiaryAccounts.push({
            id: element.id,
            name: element.name,
            code: element.code,
            type:element.type,
            selected: false,
            selectedChild: false,
          });
          // if (selected === -1) {
          // } else {
            // var duplicate = this.subsidiaryAccounts.findIndex(
            //   (x) => x.id == element.id
            // );
            // this.subsidiaryAccounts.splice(duplicate, 1);
          // }
        });
        this.disable = false;
      });
      this.subsidiaryAccounts = [];
    },
    subsidiarySelect(account) {
      account.selected = !account.selected;
    },
    subsidiarySelectedSelect(account) {
      account.selectedChild = !account.selectedChild;
    },
    sendAllToUnassign() {

        this.subsidiaryAccountsSelected = [];
        this.subsidiaryAccounts.forEach((element) => {
          element.selected = false;
        });
    },
    sendAllToAssign() {

        this.subsidiaryAccountsSelected = this.subsidiaryAccounts;
        this.subsidiaryAccountsSelected.forEach((element) => {
          element.selected = false;
        });

      
    },
    sendToUnassign() {
      this.subsidiaryAccountsSelected.forEach((element) => {
        if (element.selectedChild) {
          this.subsidiaryAccountsSelected =
            this.subsidiaryAccountsSelected.filter((x) => x.selectedChild !== true);
          element.selectedChild = false;
        }
      });
    },
    sendToAssign() {
      this.subsidiaryAccounts.forEach((element) => {
        if (element.selected) {
          if(this.subsidiaryAccountsSelected.find((x)=>x.name ===element.name)){

          }
          else{
            this.subsidiaryAccountsSelected.push(element);

          }
          element.selected = false;
        }
      });
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.disable = true;
        if (result) {

          var payload = {
            id: this.childId,
            accountsInfo: this.subsidiaryAccountsSelected,
          };

            this.updateAccount(payload).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disable = false;
              this.subsidiaryAccountsSelected = [];
              this.subsidiaryAccountsSelected = [];
              this.$router.go(-1);
            });
        
        } else {
          // form have errors
        }
      });
    },
  },
};
</script>